import { createPatternComprehension, createTriggerConsumerEmitter } from './base';

export const comprehendGCP = createTriggerConsumerEmitter({
   filterField: 'PermitNumber',
   triggers: ['gcp'],
   consume: token => /^\d{4,}$/.test(token),
   emit: token => [token, `GCP-${token}`, `GCP-O&G-${token}`, `GCP-OG-${token}`],
   notificationMessage: values =>
      `Interpreted "gcp" and subsequent numbers as Permit Number filters: ${values.filter(t => t.startsWith('GCP-')).join(', ')}.`,
});

export const comprehendNOI = createTriggerConsumerEmitter({
   filterField: 'PermitNumber',
   triggers: ['noi'],
   consume: token => /^\d{4,}$/.test(token),
   emit: token => [token, `NOI-${token}`],
   notificationMessage: values =>
      `Interpreted "noi" and subsequent numbers as Permit Number filters: ${values.filter(t => t.startsWith('NOI-')).join(', ')}.`,
});

export const comprehendPSD = createTriggerConsumerEmitter({
   filterField: 'PermitNumber',
   triggers: ['psd'],
   consume: token => /^\d{4,}$/.test(token),
   emit: token => [token, `PSD-${token}`],
   notificationMessage: values =>
      `Interpreted "psd" and subsequent numbers as Permit Number filters: ${values.filter(t => t.startsWith('PSD-')).join(', ')}.`,
});

export const comprehendNSR = createTriggerConsumerEmitter({
   filterField: 'PermitNumber',
   triggers: ['nsr'],
   consume: token => /^\d{4,}$/.test(token),
   emit: token => [token, `NSR-${token}`],
   notificationMessage: values =>
      `Interpreted "nsr" and subsequent numbers as Permit Number filters: ${values.filter(t => t.startsWith('NSR-')).join(', ')}.`,
});

export const comprehendModificationPermit = createPatternComprehension({
   filterField: 'PermitNumber',
   pattern: /^\d{4,}-?M\d+$/i,
   emit: (token) => {
      const normalized = token.replace('-', '');
      const withHyphen = normalized.replace(/M/i, '-M');
      return [normalized, withHyphen];
   },
   notificationMessage: values =>
      `Interpreted ${values.join(', ')} as Permit Number filters.`,
});
